import { createGlobalStyle } from 'styled-components';
import fundo from '../../assets/img/fundo.jpg';

const GlobalStyle = createGlobalStyle`
 .ant-layout{
     background: url(${fundo}) no-repeat center left;
     background-size: cover;
     flex-direction: row;

 }
 .img{
    width: 65%;
    padding: 1rem;
    font-family: 'Roboto', sans-serif;
    img {
    width: 100%;
    max-width: 1175px;
    }
    h1{
        font-weight: 900;
        font-size: 43px;
        color: #334f7d;
        margin: 0;
        line-height: 1;
        display: block;
    }
    h4{
        font-weight: 500;
        font-size: 30px;
        color: #00afef;
        margin: 0;
        display: block;
    }
 }
 @media (max-width: 800px) {
    .img{
        display: none;
        }
  }
`;

export default GlobalStyle;
